var React = require('react');

function IconCloseCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M828 197.1c-173.8-173.8-455.5-173.8-629.3 0s-173.8 455.5 0 629.3 455.5 173.8 629.3 0 173.8-455.5 0-629.3zM687.3 732.7L513.6 559 340 732.7c-3.8 3.8-10 3.8-13.9 0l-32.3-32.3c-3.8-3.8-3.8-10 0-13.9l173.6-173.6-173.6-173.7c-3.8-3.8-3.8-10 0-13.9l32.3-32.3c3.8-3.8 10-3.8 13.9 0l173.6 173.6L687.2 293c3.8-3.8 10-3.8 13.9 0l32.3 32.3c3.8 3.8 3.8 10 0 13.9L559.8 512.8l173.6 173.6c3.8 3.8 3.8 10 0 13.8l-32.3 32.4c-3.8 3.9-10 3.9-13.8.1z"}));
}

IconCloseCircleSolid.displayName = "IconCloseCircleSolid";

IconCloseCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCloseCircleSolid;

IconCloseCircleSolid.default = IconCloseCircleSolid;
